document.addEventListener('DOMContentLoaded', function () {
  const track = document.getElementById('carouselTrack');
  const slides = document.querySelectorAll('.carousel-slide');
  const dots = document.querySelectorAll('.carousel-dot');
  let currentSlide = 0;

  function goToSlide(index) {
    track.style.transform = 'translateX(-' + index * 100 + '%)';
    dots.forEach(dot => dot.classList.remove('active'));
    dots[index].classList.add('active');
    currentSlide = index;
  }

  dots.forEach(dot => {
    dot.addEventListener('click', function () {
      const index = parseInt(this.getAttribute('data-index'));
      goToSlide(index);
    });
  });

  goToSlide(currentSlide);

  // Optional autoplay
  setInterval(() => {
    const nextSlide = (currentSlide + 1) % slides.length;
    goToSlide(nextSlide);
  }, 5000);
});